import React, { useState } from 'react';
import { Cell, Pie, PieChart } from 'recharts';
import styles from './stats.module.css';
import { SERIES_COLORS } from './palette';
import { useStatsPrint } from './printContext';
import { formatNumber, formatPercent } from '../utils/format';

/**
 * Rosca com o total no centro e a legenda ao lado (valor e %). Passar o mouse
 * numa fatia ou na legenda destaca o item e mostra o valor dele no centro.
 *
 * `items`: [{ label, value, color?, display? }]
 */
const DonutChart = ({ items, centerValue, centerLabel, animate = true, empty = 'Nada no período.' }) => {
  const print = useStatsPrint();
  const [active, setActive] = useState(null);

  const list = (items || []).filter((item) => Number(item.value) > 0);
  if (list.length === 0) return <div className={styles.emptyChart}>{empty}</div>;
  const total = list.reduce((sum, item) => sum + Number(item.value), 0);
  const colored = list.map((item, index) => ({
    ...item,
    value: Number(item.value),
    color: item.color || SERIES_COLORS[index % SERIES_COLORS.length],
  }));
  const focused = active !== null ? colored[active] : null;
  const share = (item) => formatPercent((item.value / total) * 100);

  return (
    <div className={styles.donut} onMouseLeave={() => setActive(null)}>
      <div className={styles.donutChart}>
        <PieChart width={150} height={150}>
          <Pie
            data={colored}
            dataKey="value"
            nameKey="label"
            innerRadius={50}
            outerRadius={72}
            paddingAngle={2}
            cornerRadius={5}
            stroke="none"
            isAnimationActive={animate && !print}
            onMouseEnter={(_, index) => setActive(index)}
          >
            {colored.map((item, index) => (
              <Cell
                key={item.label}
                fill={item.color}
                fillOpacity={active === null || active === index ? 1 : 0.3}
                style={{ transition: 'fill-opacity 0.15s ease', outline: 'none' }}
              />
            ))}
          </Pie>
        </PieChart>
        <div className={styles.donutCenter}>
          <span className={styles.donutValue}>
            {focused ? (focused.display ?? formatNumber(focused.value)) : (centerValue ?? formatNumber(total))}
          </span>
          <span className={styles.donutLabel}>{focused ? share(focused) : centerLabel}</span>
        </div>
      </div>
      <div className={styles.donutLegend}>
        {colored.map((item, index) => (
          <div
            key={item.label}
            className={`${styles.donutLegendItem} ${active !== null && active !== index ? styles.donutLegendDim : ''}`}
            onMouseEnter={() => setActive(index)}
          >
            <span className={styles.dot} style={{ background: item.color }} />
            <span>{item.label}</span>
            <span className={styles.donutLegendValue}>
              {item.display ?? formatNumber(item.value)}
              <span className={styles.rankSub}>{share(item)}</span>
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default DonutChart;
